// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__cGonb","header":"Layout_header__LTb5V"};